export var ADMIN_LOJA_BRIDGE_TOKEN_KEY = 'adminLojaBridgeToken';
